/* eslint-disable react/no-direct-mutation-state */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "styled-components";

import { toast } from "react-toastify";
import { useFormik } from "formik";
import { AppRoute, UserRole } from "../../../navigations/Types";
import { TopNav } from "../../../../common/components/top-nav";
import { HeaderOption } from "../../../../common/components/top-nav/type";

import {
  Button,
  ButtonText,
} from "../../../../common/components/design-system";
import { Api } from "../../../../common/redux/services/base/api";
import { LocalStorage, Session } from "../../../../common/service";
import { Constants } from "../../../../assets/constants";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { E164Number } from "libphonenumber-js";

import "./change-phone.scss";
import i18n from 'i18n-js';

interface User {
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  userUuid: string;
}

function ChangePhone() {
  const { id: user_uuid } = useParams();
  const navigate = useNavigate();

  const theme = useTheme();
  const [userData, setUserData] = useState(null);
  const [userId, setUserId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const {
    values,
    dirty,
    errors,
    isValid,
    touched,
    handleBlur,
    handleSubmit,
    handleChange,
    isSubmitting,
    setFieldValue,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: async (params, helpers) => {},
  });

  const userOption: HeaderOption = {
    url: "/change-phone",
    title: "Change Phone",
    showLogo: false,
    rightComponent: () => (
      <div className="top-nav-right-wrapper">
        <Button
          variant="plain"
          onClick={() => navigate("/Profile")}
        >
          Cancel
        </Button>
      </div>
    ),
  };

  // @ts-ignore
  async function getUser(): Promise {
    const result = await Api.get("/api/v1/users/profile");
    if (result != null) {
      const user: User = result.data;
      setUserData(result.data);
      setUserId(user?.userUuid);
      setPhoneNumber(user?.phoneNumber);
      return Promise.resolve(result?.data);
    } else {
      return Promise.reject();
    }
  }
  useEffect(() => {
    getUser();
  }, []);

  async function updatePhone(phoneNumber: string): Promise<void> {
    try {
      const result = await Api.patch(`/api/v1/users/${userId}`, {
        phoneNumber,
      });

      if (!result) {
        throw new Error(i18n.t("message.no_result_from_api"));
      }

      setUserData(result.data);
      toast.success("Phone Number Changed Successfully");
      navigate("/Profile");
    } catch (error) {
      console.error("Error in updatePhone:", error);
      throw error;
    }
  }

  return (
    <div
      style={{ marginTop: 20 }}
      data-testid="change-phone-container"
    >
      <TopNav navigationOption={userOption} />
      <div className="guest-profile-wrapper">
        <div>
          <div style={{ marginTop: 10 }}>Phone Number</div>

          <PhoneInput
            data-testid="new-phone-input"
            type="tel"
            placeholder="Enter phone number"
            value={phoneNumber}
            flagWidth={20}
            flagHeight={20}
            onChange={(value?: E164Number) => {
              if (value) {
                setPhoneNumber(value.toString());
              } else {
                setPhoneNumber("");
              }
            }}
          />
        </div>
        <div
          data-testid="phone-number-notification-text"
          style={{ fontSize: 10, marginTop: 5 }}
        >
          You may receive SMS notifications from APAD for security and login
          purposes
        </div>

        <div style={{ marginTop: 50 }}>
          <div style={{ height: 100, width: 100 }}></div>
          <Button
            data-testid="apply-button-phone"
            //isLoading={isLoading}
            type="submit"
            size="lg"
            variant="primary"
            onClick={() => updatePhone(phoneNumber)}
          >
            <ButtonText>Apply</ButtonText>
          </Button>
        </div>
      </div>
    </div>
  );
}
const route: AppRoute = {
  name: "change-phone",
  screen: ChangePhone,
  path: "/change-phone",
  role: [UserRole.Authenticated],
};
export { ChangePhone, route };
